<template>
  <span :class="brandClass">
      <!-- <tippy :appendTo="appendToApp" :id="'tooltip-'+name" :to="name" trigger="manual" arrow :placement="placement" theme="light" :interactive="true"  :maxWidth="maxWidth">
        <template #content>
          <div id="inner-content" class="tooltip consents-tooltip" :class="brandClass">
            <div class="dismiss-button pointer" @click="closeTooltip()" aria-label="close" :id="'tooltip-close-'+name" tabindex="0" role="button" @keydown="ariaClick"></div>
            <span v-if="html" v-html="html" class="tooltip-body"></span>
            <slot></slot>
          </div>
        </template>
        
      </tippy> -->
      <tippy class="accessibility-space" :class="brandClass" :appendTo="appendToApp" :onShow="addCloseCallback" :onHide="removeCloseCallback" :id="'tooltip-'+name" trigger="click" :arrow="true" :placement="placement" theme="light" :interactive="true"  :maxWidth="maxWidth" :aria="{expanded: false}">
        <span :id="name" :aria-labelledby="labelledBy" v-if="showInfoIcon" class="picture-info pointer additional-hitbox" @keydown="ariaClick" :class="brandClass" tabindex='0' role='button'></span>
        <slot :aria-labelledby="labelledBy" @keydown="ariaClick" :class="brandClass" tabindex='0' role='button' name="externaltriggeringelement"></slot>
        <template #content>
          <div id="inner-content" class="tooltip consents-tooltip" :class="brandClass">
            <div class="dismiss-button pointer" style="z-index:2" :aria-label="$t('close_tooltip')" :id="'tooltip-close-'+name" tabindex="0" role="button" @keydown="ariaClick"></div>
              <div class="scrollable_content" tabindex="0">
                <span v-if="html" v-html="html" class="tooltip-body"></span>
                <slot name="externalcontent"></slot>
              </div>
          </div>
        </template>



      </tippy>
        <!-- <tippy content="Hi!">
          <button>Tippy!</button>
        </tippy> -->

  </span>
</template>

<script>

/** TIPPY **/
// import { plugin as VueTippy } from 'vue-tippy'
import { Tippy } from 'vue-tippy'

import oneUtils from "../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
export default {
  inject:['$t'],
  mixins:[oneUtils.accessibilityMixin],
  name: 'OneTippy',
  data: () => ({
    instance: null
  }),
  components:{Tippy},
  props: { 
    showInfoIcon:{
      type: Boolean,
      required: false,
      default: true
    },
    brandClass:{
      type: String,
      required: false,
      default: '__b'
    },
    name:{
      type: String,
      required: true,
    },
    labelledBy:{
      type: String,
      required: true,
    },
    html:{
      type: String,
      required: false,
    },
    maxWidth:{
      type: Number,
      required: false,
    },
    placement:{
      type: String,
      required: true,
    }
  },
  methods:{
    addCloseCallback(instance){
      this.giveFocus();
      this.instance = instance;
      instance.popper.querySelector('.dismiss-button').addEventListener('click', () => {
        document.getElementById(this.name).focus();
        instance.hide();
      });
    },
    removeCloseCallback(instance) {
    instance.popper.querySelector('.dismiss-button').removeEventListener('click', () => {
      document.getElementById(this.name).focus();
      instance.hide();
    });
  },
    giveFocus(){
      setTimeout(() => {
        document.getElementById('tooltip-close-'+this.name).focus();
        const container = document.getElementById('inner-content');
        if(container) {
          const list = container.querySelectorAll('[tabindex = "0"], a');
          this.navigateInModal(list, this.closeTooltip);
        }
      }, 200);
    },
    appendToApp: () =>  document.querySelector("#app"),
    closeTooltip(){
      this.instance.hide();
      document.getElementById(this.name).focus();
    },
  }
}
</script>
<style lang="scss">
@import "tippy.js/themes/light";
@import "tippy.js/dist/tippy"; 

@import './styles/_fonts.scss';
@import './styles/_variables.scss';

#app{
  .accessibility-space {
    padding: 12px;
    margin: -12px;
    &.__b {
          padding: 12.5px 11.5px;
    }
  }

  .picture-info{
    background-image: url('@/assets/default/light/info-default-light.svg');
    width: 11px;
    height: 11px;
    background-repeat: no-repeat;
    margin-left: 10px;
    background-size: contain;
    display: inline-block;
    bottom: 0;
    &:hover{
      outline: auto;
    }
    &.__d{
      background-image: url('@/assets/default/dark/info-default-dark.svg');
    }
    &.__m{
      background-image: url('@/assets/mini/light/info-mini-light.svg');
      width: 13px;
      height: 13px;
      margin-left: 5px;
      margin-bottom: -2px;
      &.__d{
        background-image: url('@/assets/mini/dark/info-mini-dark.svg');
      }
    }
    &.__motorrad{
      background-image: url('@/assets/motorrad/light/info-motorrad-light.svg');

      &.__d{
        background-image: url('@/assets/default/dark/info-default-dark.svg');
      }
    }
  }
  .tippy-box{
    border-radius: 5px;
    // .tippy-tooltip{
    //   padding: 0;
    // }
    .tippy-content{ 
      color: $black;
      text-align: left;
      // max-width: 240px;
      padding: 30px 20px 20px;
      position: relative;
      font-family: BMWTypeNext;
      .scrollable_content{        
        max-height: 240px;
        overflow-y: scroll;
      }
      a{
        color: $black;
        text-decoration: underline;
        font-weight: bold;
        display: inline-block;
        &:hover {
          text-decoration: none;
        }
      }
      .tooltip-title {
        font-weight: bold;
        margin-bottom: 12px;
      }
      .tooltip-body {
        font-weight: 300;
      }
      .dismiss-button {
        background-image: url("@/assets/default/light/close-grey-default-light.svg");
        background-size: contain;
        background-repeat: no-repeat;
        width: 20px;
        height: 18px;
        position: absolute;
        top: 10px;
        right: 10px;
        &:hover{
          outline: auto;
        }
      }
    }
  }
  &.__m{
    .tippy-box{
      .tippy-content{
        max-width: 100vw;
        color: white;
        background-color: black;
        font-family: MINISansSerif;
        a{
          font-family: MINISansSerif;
          color: $miniLink;
        }
      }
    }
    .tippy-box[data-theme~='light'][data-placement^='top'] > .tippy-arrow::before {
      border-top: 8px solid black;
    }
    .tippy-box[data-theme~='light'][data-placement^='bottom']
      > .tippy-arrow::before {
      border-bottom: 8px solid black;
    }
  }
  &.__motorrad {
        .tippy-box{
          .tippy-content{
            font-family: BMWMotorrad;
          }
    }
  }
  &.__t{
     .tippy-box{
      .tippy-content{
        font-family: ToyotaSemibold;
        a{
          color: $dusty;
          &:hover {
            text-decoration: none;
            color: $toyotared;
          }
        }
      }
    }
  }
  &.__alphabet{
     .tippy-box{
      .tippy-content{
       font-family: AlphabetSansPro-Light;
      }
    }
  }
  &.__alphera{
     .tippy-box{
      .tippy-content{
        font-family: TahomaAlphera;
      }
    }
  }
  &.__d{
    .tippy-box{
      background-color: $bmwdarkmodebg;
      .tippy-content{
        color: white;
        a{
          color: white;
        }
      }
    }
    .tippy-box[data-theme~='light'][data-placement^='top'] > .tippy-arrow::before {
      border-top: 8px solid $bmwdarkmodebg;
    }
    .tippy-box[data-theme~='light'][data-placement^='bottom']
      > .tippy-arrow::before {
      border-bottom: 8px solid $bmwdarkmodebg;
    }
  }
}


</style>

